import { createApp } from 'vue'
import App from './App.vue'
import router from '../router'; // 导入路由文件
import "./tailwind.css" // 导入 tailwind.css
import pinia from "../store/pinia"

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import Vue3Marquee from 'vue3-marquee'

import { register } from 'swiper/element/bundle';
register();

const app = createApp(App)

// app.config.compilerOptions.isCustomElement = (tag) => tag.includes('swiper-')

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, far, fab)

app.use(router)
app.use(pinia)
app.use(ElementPlus)
app.use(Vue3Marquee)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')

